import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import Button from '../base/Button';
import { onRoleDenied } from '../../permissions/roleDenial';

/**
 * The one modal that answers "why did nothing happen when I pressed that?".
 *
 * Mounted once, in App.js, and fed by every axios instance in the application
 * (src/permissions/roleDenial.js). Pages need to do nothing to opt in — which is
 * the point, because the refusal can come from any button on any screen now that
 * every role can open every screen.
 */
const RoleDeniedModal = () => {
  const [denial, setDenial] = useState(null);

  useEffect(() => onRoleDenied(setDenial), []);

  const close = () => setDenial(null);

  return (
    <Modal show={!!denial} onHide={close} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <span
            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning-100 text-warning-600"
            style={{ width: 36, height: 36 }}
          >
            <FeatherIcon icon="lock" size={18} />
          </span>
          <span className="fs-7">Nu ai permisiunea necesara</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-3">
        <p className="mb-2 fw-semibold text-1000">{denial?.error}</p>
        <p className="mb-3 text-700">{denial?.detail}</p>

        {denial?.serverMessage && (
          <p className="mb-3 text-700 fs-9">{denial.serverMessage}</p>
        )}

        {/* What was refused, for when somebody has to ask a colleague about it. */}
        {denial?.action && (
          <div className="border-top pt-2 text-800 fs-9 font-monospace">
            {denial.action}
            {denial.role && <span className="ms-2">· rol: {denial.role}</span>}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button variant="primary" onClick={close}>
          Am inteles
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleDeniedModal;
